export default function PHP_haschildren() {
  return (
    <div>
      <h1>PHP_haschildren</h1>
    </div>
  );
}
